export default __webpack_public_path__ + "static/media/g-4.c99a405a.jpg";